import { FolderClosed } from 'ui/icons/action/FolderClosed';
import { FolderOpen } from 'ui/icons/action/FolderOpen';
import { colors } from 'ui/theme/colors';

type Props = {
  isDisabled: boolean;
  isOpen: boolean;
};

export const TreeFolderIcon = ({ isDisabled, isOpen }: Props) => {
  if (isDisabled) {
    return <FolderClosed color={colors.grey25} data-test="disabled-folder-closed-icon" />;
  }

  if (isOpen) {
    return <FolderOpen data-test="folder-open-icon" />;
  }

  return <FolderClosed data-test="folder-closed-icon" />;
};
